<script lang="ts" setup>
// 导入图片 - Web端
import productSpecs1 from '~/assets/images/productSpecs-1000bit.png'
import productSpecs2 from '~/assets/images/productSpecs-550bit.png'
import productSpecs3 from '~/assets/images/productSpecs-100bit.png'

// 导入图片 - 移动端
import productSpecsMobile1 from '~/assets/images/productSpecs-mobile-1000bit.png'
import productSpecsMobile2 from '~/assets/images/productSpecs-mobile-550bit.png'
import productSpecsMobile3 from '~/assets/images/productSpecs-mobile-100bit.png'

const { t, tm, rt } = useI18n()
const { trackEvent } = useCnzz()

definePageMeta({ layout: 'page' })
useHead({
  title: t('productHardware.pageSubTitle'),
  meta: [
    {
      name: 'description',
      content: t('seo.productSpecs.description'),
    },
    {
      name: 'keywords',
      content: t('seo.productSpecs.keywords'),
    },
    {
      property: 'og:title',
      content: t('seo.productSpecs.title'),
    },
    {
      property: 'og:description',
      content: t('seo.productSpecs.description'),
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:image',
      content: 'https://www.qboson.com/favicon.ico',
    },
    {
      property: 'og:locale',
      content: 'zh_CN',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:title',
      content: t('seo.productSpecs.title'),
    },
    {
      name: 'twitter:description',
      content: t('seo.productSpecs.description'),
    },
    {
      name: 'twitter:image',
      content: 'https://www.qboson.com/favicon.ico',
    },
    {
      name: 'author',
      content: '玻色量子',
    },
  ],
})

// 移动端轮播状态
const currentSlide = ref(0)
const touchStartX = ref(0)
const touchEndX = ref(0)
let autoPlayTimer: NodeJS.Timeout | null = null

// 产品数据
const products = computed(() => [
  {
    key: 'CQ-D-1000T-shanhai',
    name: t('productSpecs.products.1000bit-shanhai.name'),
    workingTime: {
      label: t('productSpecs.products.1000bit-shanhai.workingTime.label'),
      value: t('productSpecs.products.1000bit-shanhai.workingTime.value'),
    },
    deliveryTime: {
      label: t('productSpecs.products.1000bit-shanhai.deliveryTime.label'),
      value: t('productSpecs.products.1000bit-shanhai.deliveryTime.value'),
    },
    smartControl: {
      title: t('productSpecs.products.1000bit-shanhai.smartControl.title'),
      training: {
        label: t(
          'productSpecs.products.1000bit-shanhai.smartControl.training.label',
        ),
        specs: [
          t(
            'productSpecs.products.1000bit-shanhai.smartControl.training.specs.0',
          ),
          t(
            'productSpecs.products.1000bit-shanhai.smartControl.training.specs.1',
          ),
        ],
      },
      inference: {
        label: t(
          'productSpecs.products.1000bit-shanhai.smartControl.inference.label',
        ),
        specs: [
          t(
            'productSpecs.products.1000bit-shanhai.smartControl.inference.specs.0',
          ),
          t(
            'productSpecs.products.1000bit-shanhai.smartControl.inference.specs.1',
          ),
        ],
      },
    },
    image:
      'https://images-cloud.qboson.com/website/shanhai1000/1000T-shanhai.png',
    mobileImage:
      'https://images-cloud.qboson.com/website/shanhai1000/1000T-shanhai-mobile.png',
  },
  {
    key: 'CQ-D-1000',
    name: t('productSpecs.products.1000bit.name'),
    workingTime: {
      label: t('productSpecs.products.1000bit.workingTime.label'),
      value: t('productSpecs.products.1000bit.workingTime.value'),
    },
    deliveryTime: {
      label: t('productSpecs.products.1000bit.deliveryTime.label'),
      value: t('productSpecs.products.1000bit.deliveryTime.value'),
    },
    smartControl: {
      title: t('productSpecs.products.1000bit.smartControl.title'),
      training: {
        label: t('productSpecs.products.1000bit.smartControl.training.label'),
        specs: [
          t('productSpecs.products.1000bit.smartControl.training.specs.0'),
          t('productSpecs.products.1000bit.smartControl.training.specs.1'),
        ],
      },
      inference: {
        label: t('productSpecs.products.1000bit.smartControl.inference.label'),
        specs: [
          t('productSpecs.products.1000bit.smartControl.inference.specs.0'),
          t('productSpecs.products.1000bit.smartControl.inference.specs.1'),
        ],
      },
    },
    image: productSpecs1,
    mobileImage: productSpecsMobile1,
  },
  {
    key: 'CQ-D-550',
    name: t('productSpecs.products.550bit.name'),
    workingTime: {
      label: t('productSpecs.products.550bit.workingTime.label'),
      value: t('productSpecs.products.550bit.workingTime.value'),
    },
    deliveryTime: {
      label: t('productSpecs.products.550bit.deliveryTime.label'),
      value: t('productSpecs.products.550bit.deliveryTime.value'),
    },
    smartControl: {
      title: t('productSpecs.products.550bit.smartControl.title'),
      training: {
        label: t('productSpecs.products.550bit.smartControl.training.label'),
        specs: [
          t('productSpecs.products.550bit.smartControl.training.specs.0'),
          t('productSpecs.products.550bit.smartControl.training.specs.1'),
        ],
      },
      inference: {
        label: t('productSpecs.products.550bit.smartControl.inference.label'),
        specs: [
          t('productSpecs.products.550bit.smartControl.inference.specs.0'),
          t('productSpecs.products.550bit.smartControl.inference.specs.1'),
        ],
      },
    },
    image: productSpecs3,
    mobileImage: productSpecsMobile3,
  },
  {
    key: 'CQ-D-100',
    name: t('productSpecs.products.100bit.name'),
    workingTime: {
      label: t('productSpecs.products.100bit.workingTime.label'),
      value: t('productSpecs.products.100bit.workingTime.value'),
    },
    deliveryTime: {
      label: t('productSpecs.products.100bit.deliveryTime.label'),
      value: t('productSpecs.products.100bit.deliveryTime.value'),
    },
    smartControl: {
      title: t('productSpecs.products.100bit.smartControl.title'),
      training: {
        label: t('productSpecs.products.100bit.smartControl.training.label'),
        specs: [
          t('productSpecs.products.100bit.smartControl.training.specs.0'),
          t('productSpecs.products.100bit.smartControl.training.specs.1'),
        ],
      },
      inference: {
        label: t('productSpecs.products.100bit.smartControl.inference.label'),
        specs: [
          t('productSpecs.products.100bit.smartControl.inference.specs.0'),
          t('productSpecs.products.100bit.smartControl.inference.specs.1'),
        ],
      },
    },
    image: productSpecs2,
    mobileImage: productSpecsMobile2,
  },
])

// 自动轮播函数
const startAutoPlay = () => {
  stopAutoPlay()
  autoPlayTimer = setInterval(() => {
    nextSlide()
  }, 5000)
}

const stopAutoPlay = () => {
  if (autoPlayTimer) {
    clearInterval(autoPlayTimer)
    autoPlayTimer = null
  }
}

const resetAutoPlay = () => {
  stopAutoPlay()
  startAutoPlay()
}

// 移动端轮播函数
const goToSlide = (index: number) => {
  currentSlide.value = index
  resetAutoPlay()
}

const nextSlide = () => {
  currentSlide.value = (currentSlide.value + 1) % products.value.length
}

const prevSlide = () => {
  currentSlide.value =
    (currentSlide.value - 1 + products.value.length) % products.value.length
}

const handleTouchStart = (e: TouchEvent) => {
  touchStartX.value = e.touches[0].clientX
  stopAutoPlay()
}

const handleTouchMove = (e: TouchEvent) => {
  touchEndX.value = e.touches[0].clientX
}

const handleTouchEnd = () => {
  if (touchStartX.value - touchEndX.value > 50) {
    nextSlide()
  }
  if (touchEndX.value - touchStartX.value > 50) {
    prevSlide()
  }
  resetAutoPlay()
}

// 组件挂载时启动自动轮播
onMounted(() => {
  startAutoPlay()
  trackEvent('硬件产品', '访问', '产品对比页')
})

// 组件卸载时清除定时器
onUnmounted(() => {
  stopAutoPlay()
})

// 参数配置表数据 - 直接定义结构
const tableModules = [
  { category: '算力参数', rows: 11 },
  { category: '硬件参数', rows: 4 },
  { category: '可靠性', rows: 4 },
  { category: '第三方认证', rows: 1 },
]

// 山海1000的三种运算模式数据
const shanhaiModes = ref(['标准1000S', '精准1000P', '超频1000E'])
const activeShanhaiModeIndex = ref(0)

const prevShanhaiMode = () => {
  if (activeShanhaiModeIndex.value < shanhaiModes.value.length - 1) {
    activeShanhaiModeIndex.value++
  } else {
    activeShanhaiModeIndex.value = 0
  }
}

const nextShanhaiMode = () => {
  if (activeShanhaiModeIndex.value > 0) {
    activeShanhaiModeIndex.value--
  } else {
    activeShanhaiModeIndex.value = shanhaiModes.value.length - 1
  }
}

const getShanhaiData = (moduleIndex: number, rowIndex: number) => {
  const key = `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex}.1000bit-shanhai`
  const val = tm(key)
  if (Array.isArray(val)) {
    return rt(val[activeShanhaiModeIndex.value] as any)
  }
  return rt(val as any)
}

// 表格数据行
const getRowData = (moduleIndex: number, rowIndex: number) => {
  const baseIndex = moduleIndex * 10 + rowIndex
  return {
    label: t(
      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex}.label`,
    ),
    '1000bit': t(
      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex}.1000bit`,
    ),
    '550bit': t(
      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex}.550bit`,
    ),
    '100bit': t(
      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex}.100bit`,
    ),
  }
}
</script>

<template>
  <div class="min-h-screen w-full">
    <!-- web端 -->
    <div class="hidden md:block min-h-screen w-full">
      <!-- 产品参数详情 -->
      <section class="bg-[#F9FBFF]">
        <div class="w-full flex">
          <!-- 产品卡片循环 -->
          <div
            v-for="product in products"
            :key="product.key"
            class="flex-1 pt-[100px] pb-[50px] flex flex-col cursor-pointer"
            :class="`product-bg-${product.key}`"
          >
            <div
              class="product-info py-[26px] px-[40px]"
              style="backdrop-filter: blur(5px)"
            >
              <h2 class="text-[26px] text-[#000] font-normal mb-[19px]">
                {{ product.name }}
              </h2>
              <div class="flex gap-[40px]">
                <div class="w-auto">
                  <div class="text-[14px] text-[#000] font-normal mb-[5px]">
                    {{ product.workingTime.label }}
                  </div>
                  <div class="text-[18px] text-[#000] font-medium">
                    {{ product.workingTime.value }}
                  </div>
                </div>

                <div class="w-auto">
                  <div class="text-[14px] text-[#000] font-normal mb-[5px]">
                    {{ product.deliveryTime.label }}
                  </div>
                  <div class="text-[18px] text-[#000] font-medium">
                    {{ product.deliveryTime.value }}
                  </div>
                </div>
              </div>

              <div class="mt-[19px]">
                <div
                  class="text-[15px] text-[#000] font-medium leading-[21px] mb-[10px]"
                >
                  {{ product.smartControl.title }}
                </div>
                <!-- <div class="text-[13px] text-[#333] mb-[6px] font-normal">
                  {{ product.smartControl.training.label }}
                </div>
                <div class="text-[12px] text-[#666] leading-[18px] font-normal">
                  <div
                    v-for="(spec, index) in product.smartControl.training.specs"
                    :key="index"
                    class="mb-[6px]"
                  >
                    {{ spec }}
                  </div>
                </div> -->
              </div>

              <div class="mt-[10px]">
                <!-- <div class="text-[13px] text-[#333] font-normal mb-[2px]">
                  {{ product.smartControl.inference.label }}
                </div>
                <div class="text-[12px] text-[#666] leading-[18px] font-normal">
                  <div
                    v-for="(spec, index) in product.smartControl.inference
                      .specs"
                    :key="index"
                    class="mb-[6px]"
                  >
                    {{ spec }}
                  </div>
                </div> -->
              </div>
            </div>

            <div
              class="mx-[40px] flex items-center justify-center mt-[165px] min-h-[315px]"
            >
              <img
                :src="product.image"
                :alt="`${product.name}产品`"
                class="max-w-full max-h-[315px] object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- 产品参数配置表 -->
      <section class="params-table-section pt-[80px] pb-[100px]">
        <h2 class="text-[34px] font-medium text-[#3D3D3D] mb-[52px] px-[65px]">
          {{ t('productSpecs.table.title') }}
        </h2>
        <div class="params-table">
          <!-- 表头 -->
          <div class="flex mb-[57px] border-b border-[#E5E5E5] px-[65px]">
            <!-- 左侧空白列，对齐分类列 -->
            <div class="w-[200px]"></div>
            <!-- 标签列空白 -->
            <div class="w-[180px] mr-[120px]"></div>
            <!-- 三个产品列 -->
            <div
              class="flex-1 text-center text-[24px] font-medium text-[#000] leading-[34px] pb-[12px]"
            >
            驭量·山海1000
            </div>
            <div
              class="flex-1 text-center text-[24px] font-medium text-[#000] leading-[34px] pb-[12px]"
            >
              CQ-D-1000
            </div>
            <div
              class="flex-1 text-center text-[24px] font-medium text-[#000] leading-[34px] pb-[12px]"
            >
              CQ-D-550
            </div>
            <div
              class="flex-1 text-center text-[24px] font-medium text-[#000] leading-[34px] pb-[12px]"
            >
              CQ-D-100
            </div>
          </div>

          <!-- 表格内容 -->
          <div
            v-for="(module, moduleIndex) in tableModules"
            :key="moduleIndex"
            class="flex mx-[65px]"
            :class="moduleIndex % 2 === 0 ? 'bg-[#F1F1F1]' : 'bg-[#FFFFFF]'"
          >
            <!-- 左侧分类列 -->
            <div class="w-[200px] flex items-center justify-center">
              <div class="text-[26px] font-medium text-[#000] leading-[34px]">
                {{ module.category }}
              </div>
            </div>

            <!-- 右侧数据区域 -->
            <div class="flex-1">
              <div
                v-for="rowIndex in module.rows"
                :key="rowIndex"
                class="flex items-center py-[23px]"
              >
                <div
                  class="w-[200px] mr-[120px] text-[20px] font-medium text-[#333] leading-[34px]"
                >
                  {{
                    t(
                      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.label`,
                    )
                  }}
                </div>
                <div class="flex-1 flex">
                  <!-- 参数相同的行：单个居中显示 -->
                  <template v-if="moduleIndex === 2 && [4].includes(rowIndex)">
                    <div
                      class="w-full text-center text-[18px] font-medium text-[#3D3D3D] leading-[42px]"
                    >
                      {{
                        t(
                          `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.1000bit`,
                        )
                      }}
                    </div>
                  </template>
                  <!-- 其他行：三列显示 -->
                  <template v-else>
                    <div
                      class="w-[180px] flex-1 text-center text-[18px] font-medium leading-[42px] relative flex justify-center items-center"
                    >
                      <template v-if="moduleIndex === 0 && rowIndex === 1">
                        <div
                          class="flex items-center gap-[10px] text-[#666] px-[10px] h-[36px]"
                        >
                          <svg
                            class="w-[15px] h-[8px] cursor-pointer text-[#1877BC] hover:opacity-80"
                            viewBox="0 0 15 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="transform: rotate(90deg)"
                            @click="prevShanhaiMode"
                          >
                            <path
                              d="M14 1L7.5 7L1 1"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span class="text-[16px] font-medium text-[#000]">{{
                            shanhaiModes[activeShanhaiModeIndex]
                          }}</span>
                          <svg
                            class="w-[15px] h-[8px] cursor-pointer text-[#1877BC] hover:opacity-80"
                            viewBox="0 0 15 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="transform: rotate(-90deg)"
                            @click="nextShanhaiMode"
                          >
                            <path
                              d="M14 1L7.5 7L1 1"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </template>
                      <template v-else>
                        <span class="text-[#3D3D3D]">
                          {{ getShanhaiData(moduleIndex, rowIndex - 1) }}
                        </span>
                      </template>
                    </div>
                    <div
                      class="w-[180px] flex-1 text-center text-[18px] font-medium text-[#3D3D3D] leading-[42px]"
                    >
                      {{
                        t(
                          `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.1000bit`,
                        )
                      }}
                    </div>
                    <div
                      class="w-[180px] flex-1 text-center text-[18px] font-medium text-[#3D3D3D] leading-[42px]"
                    >
                      {{
                        t(
                          `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.550bit`,
                        )
                      }}
                    </div>
                    <div
                      class="w-[180px] flex-1 text-center text-[18px] font-medium text-[#3D3D3D] leading-[42px]"
                    >
                      {{
                        t(
                          `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.100bit`,
                        )
                      }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- mobile端 -->
    <div class="md:hidden w-full">
      <!-- 产品参数详情轮播 -->
      <section
        class="relative w-full h-[620px] pt-[70px] pb-[38px] overflow-hidden transition-all duration-300"
        :class="`product-mobile-bg-${products[currentSlide].key}`"
      >
        <div
          class="relative w-full h-full"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
        >
          <!-- 轮播容器 -->
          <div
            class="flex h-full transition-transform duration-300 ease-in-out"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          >
            <!-- 产品卡片循环 -->
            <div
              v-for="product in products"
              :key="product.key"
              class="w-full h-full flex-shrink-0 flex flex-col"
            >
              <div class="px-[20px] pb-[6px]">
                <h2 class="text-[24px] text-[#000] font-normal mb-[7px]">
                  {{ product.name }}
                </h2>

                <div class="flex gap-[43px] mb-[15px]">
                  <div class="flex-1">
                    <div
                      class="text-[12px] text-[#000] font-normal mb-[4px] opacity-80"
                    >
                      {{ product.workingTime.label }}
                    </div>
                    <div
                      class="text-[14px] text-[#000] font-normal leading-[20px]"
                    >
                      {{ product.workingTime.value }}
                    </div>
                  </div>

                  <div class="flex-1">
                    <div
                      class="text-[12px] text-[#000] font-normal mb-[4px] opacity-80"
                    >
                      {{ product.deliveryTime.label }}
                    </div>
                    <div
                      class="text-[14px] text-[#000] font-normal leading-[20px]"
                    >
                      {{ product.deliveryTime.value }}
                    </div>
                  </div>
                </div>

                <div class="mb-[9px]">
                  <div
                    class="text-[12px] text-[#000] font-medium leading-[18px] mb-[7px]"
                  >
                    {{ product.smartControl.title }}
                  </div>
                  <!-- <div class="text-[10px] text-[#333] mb-[4px] font-normal">
                    {{ product.smartControl.training.label }}
                  </div>
                  <div
                    class="text-[10px] text-[#666] leading-[16px] font-normal"
                  >
                    <div
                      v-for="(spec, index) in product.smartControl.training
                        .specs"
                      :key="index"
                      class="mb-[4px]"
                    >
                      {{ spec }}
                    </div>
                  </div> -->
                </div>

                <!-- <div>
                  <div class="text-[10px] text-[#333] font-normal mb-[4px]">
                    {{ product.smartControl.inference.label }}
                  </div>
                  <div
                    class="text-[10px] text-[#666] leading-[16px] font-normal"
                  >
                    <div
                      v-for="(spec, index) in product.smartControl.inference
                        .specs"
                      :key="index"
                      class="mb-[4px]"
                    >
                      {{ spec }}
                    </div>
                  </div>
                </div> -->
              </div>

              <!-- 产品图片 -->
              <div
                class="flex items-center justify-center mt-[122px] px-[12px]"
              >
                <div
                  class="w-full max-w-[350px] flex items-center justify-center"
                >
                  <img
                    :src="product.mobileImage"
                    :alt="`${product.name}产品`"
                    class="max-w-[350px] max-h-[250px] w-auto h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 轮播指示器 -->
        <div
          class="absolute bottom-[18px] left-0 right-0 flex justify-center gap-[4px] z-10"
        >
          <button
            v-for="(product, index) in products"
            :key="index"
            class="mobile-carousel-indicator w-[30px] h-[3px] rounded-full transition-all duration-300"
            :class="
              currentSlide === index
                ? 'mobile-indicator-active'
                : 'mobile-indicator-inactive'
            "
            :aria-label="`切换到${product.name}`"
            @click="goToSlide(index)"
          />
        </div>
      </section>

      <!-- 产品参数配置表 -->
      <section class="w-full bg-[#FFFFFF]">
        <h2
          class="text-[16px] font-normal text-[#000] mb-[20px] px-[16px] pt-[23px]"
        >
          {{ t('productSpecs.table.title') }}
        </h2>

        <!-- 移动端表格 -->
        <div class="mobile-params-table px-[7px]">
          <!-- 循环每个模块 -->
          <div
            v-for="(module, moduleIndex) in tableModules"
            :key="moduleIndex"
            class="mb-[12px] rounded-[4px] border border-[#EEEEEE] overflow-x-auto custom-scrollbar"
          >
            <!-- 内容包装器，强制最小宽度以产生横向滚动，不换行 -->
            <div class="w-max min-w-full whitespace-nowrap">
              <!-- 模块标题行（灰色背景） -->
              <div class="flex bg-[#F1F1F1] w-max min-w-full">
                <div
                  class="w-[120px] flex-shrink-0 py-[12px] px-[10px] text-[12px] font-normal text-[#000]"
                >
                  {{ module.category }}
                </div>
                <div
                  v-if="moduleIndex === 0"
                  class="w-[145px] flex-shrink-0 py-[12px] px-[8px] text-[12px] font-normal text-[#000] text-center"
                >
                驭量·山海1000
                </div>
                <div
                  v-if="moduleIndex === 0"
                  class="w-[145px] flex-shrink-0 py-[12px] px-[8px] text-[12px] font-normal text-[#000] text-center"
                >
                  CQ-D-1000
                </div>
                <div
                  v-if="moduleIndex === 0"
                  class="w-[145px] flex-shrink-0 py-[12px] px-[8px] text-[12px] font-normal text-[#000] text-center"
                >
                  CQ-D-550
                </div>
                <div
                  v-if="moduleIndex === 0"
                  class="w-[145px] flex-shrink-0 py-[12px] px-[8px] text-[12px] font-normal text-[#000] text-center"
                >
                  CQ-D-100
                </div>
              </div>

              <!-- 模块数据行（白色背景） -->
              <div
                v-for="rowIndex in module.rows"
                :key="rowIndex"
                class="flex bg-[#FFFFFF] w-max min-w-full"
              >
                <div
                  class="w-[120px] flex-shrink-0 pt-[14px] pb-[12px] px-[10px] text-[12px] text-[#000] font-normal leading-[18px]"
                >
                  {{
                    t(
                      `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.label`,
                    )
                  }}
                </div>
                <!-- 参数相同的行：单个居中显示 -->
                <template v-if="moduleIndex === 2 && [4].includes(rowIndex)">
                  <div
                    class="w-[560px] flex-shrink-0 pt-[14px] pb-[12px] px-[8px] text-[12px] text-[#000] font-medium text-center leading-[18px]"
                  >
                    {{
                      t(
                        `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.1000bit`,
                      )
                    }}
                  </div>
                </template>
                <!-- 其他行：三列显示 -->
                <template v-else>
                  <div
                    class="w-[145px] flex-shrink-0 pt-[14px] pb-[12px] px-[8px] text-[12px] text-[#000] font-medium text-center leading-[18px] flex items-center justify-center whitespace-normal"
                  >
                    <template v-if="moduleIndex === 0 && rowIndex === 1">
                      <div
                        class="flex items-center gap-[5px] text-[#666] px-[5px] cursor-pointer"
                      >
                        <svg
                          class="w-[10px] h-[6px] cursor-pointer text-[#1877BC] hover:opacity-80"
                          viewBox="0 0 15 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style="transform: rotate(90deg)"
                          @click="prevShanhaiMode"
                        >
                          <path
                            d="M14 1L7.5 7L1 1"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span class="text-[12px] text-[#000000]">{{
                          shanhaiModes[activeShanhaiModeIndex]
                        }}</span>
                        <svg
                          class="w-[10px] h-[6px] cursor-pointer text-[#1877BC] hover:opacity-80"
                          viewBox="0 0 15 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style="transform: rotate(-90deg)"
                          @click="nextShanhaiMode"
                        >
                          <path
                            d="M14 1L7.5 7L1 1"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </template>
                    <template v-else>
                      <span class="text-[#000]">
                        {{ getShanhaiData(moduleIndex, rowIndex - 1) }}
                      </span>
                    </template>
                  </div>
                  <div
                    class="w-[145px] whitespace-normal flex-shrink-0 pt-[14px] pb-[12px] px-[8px] text-[12px] text-[#000] font-medium text-center leading-[18px]"
                  >
                    {{
                      t(
                        `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.1000bit`,
                      )
                    }}
                  </div>
                  <div
                    class="w-[145px] whitespace-normal flex-shrink-0 pt-[14px] pb-[12px] px-[8px] text-[12px] text-[#000] font-medium text-center leading-[18px]"
                  >
                    {{
                      t(
                        `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.550bit`,
                      )
                    }}
                  </div>
                  <div
                    class="w-[145px] whitespace-normal flex-shrink-0 pt-[14px] pb-[12px] px-[8px] text-[12px] text-[#000] font-medium text-center leading-[18px]"
                  >
                    {{
                      t(
                        `productSpecs.table.modules.${moduleIndex}.rows.${rowIndex - 1}.100bit`,
                      )
                    }}
                  </div>
                </template>
              </div>
            </div>
            <!-- 结束 min-w-[800px] 包装器 -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped>
/* 阴影 */
.gradient-shadow {
  box-shadow: 0px 7px 30px 8px #dae0ed;
}

.product-info {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 产品卡片背景图 */
.product-bg-CQ-D-1000T-shanhai {
  background-image: url('https://images-cloud.qboson.com/website/shanhai1000/bg-1000T-shanhai.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 0.3s ease-in-out;
}
.product-bg-CQ-D-1000T-shanhai:hover {
  background-image: url('https://images-cloud.qboson.com/website/shanhai1000/bg-1000T-shanhai-active.jpg');
}

.product-bg-CQ-D-1000 {
  background-image: url('../../../assets/images/productSpecs-bg-1000bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 0.3s ease-in-out;
}

.product-bg-CQ-D-1000:hover {
  background-image: url('../../../assets/images/productSpecs-active-bg-1000bit.png');
}

.product-bg-CQ-D-550 {
  background-image: url('../../../assets/images/productSpecs-bg-550bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 0.3s ease-in-out;
}

.product-bg-CQ-D-550:hover {
  background-image: url('../../../assets/images/productSpecs-active-bg-550bit.png');
}

.product-bg-CQ-D-100 {
  background-image: url('../../../assets/images/productSpecs-bg-100bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-image 0.3s ease-in-out;
}

.product-bg-CQ-D-100:hover {
  background-image: url('../../../assets/images/productSpecs-active-bg-100bit.png');
}

/* 参数配置表样式 */
.params-table-section {
  background: #fff;
}

.params-table {
  width: 100%;
}

/* 移动端产品卡片背景图 */
.product-mobile-bg-CQ-D-1000T-shanhai {
  background-image: url('https://images-cloud.qboson.com/website/shanhai1000/bg-1000T-shanhai-mobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.product-mobile-bg-CQ-D-1000 {
  background-image: url('../../../assets/images/productSpecs-mobile-bg-1000bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.product-mobile-bg-CQ-D-550 {
  background-image: url('../../../assets/images/productSpecs-mobile-bg-550bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.product-mobile-bg-CQ-D-100 {
  background-image: url('../../../assets/images/productSpecs-mobile-bg-100bit.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 移动端参数配置表样式 */
.mobile-params-table {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-params-table::-webkit-scrollbar {
  display: none;
}

/* 移动端轮播指示器 */
.mobile-carousel-indicator {
  box-shadow: 0px 2px 4px 0px rgba(218, 224, 237, 0.5);
}

.mobile-indicator-active {
  background: linear-gradient(90deg, #36ba93 0%, #47c3e1 50%, #073c89 100%);
}

.mobile-indicator-inactive {
  background: #e5e7eb;
}

/* 自定义横向滚动条 */
.custom-scrollbar::-webkit-scrollbar {
  height: 2px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d1d1d6;
  border-radius: 1px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
</style>
